import React from 'react';
import {
  Box,
  Typography,
  TextField,
  IconButton,
  Avatar,
  Badge,
  List,
  ListItemButton,
  ListItemAvatar,
  ListItemText,
  Divider,
  CircularProgress,
} from '@mui/material';
import { Search } from '@mui/icons-material';

const getInitials = (name = '') =>
  name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((n) => n[0]?.toUpperCase())
    .join('') || '?';

// Left pane: searchable list of customer conversations.
// Presentational only — real data + selection are owned by the Inbox page
// and passed in via props (no direct fetching here).
const UserList = ({
  conversations = [],
  loading = false,
  selectedId = null,
  onSelect,
  search = '',
  onSearchChange,
}) => (
  <>
    <Box p={1.5}>
      <TextField
        fullWidth
        size="small"
        placeholder="Search conversations..."
        value={search}
        onChange={(e) => onSearchChange?.(e.target.value)}
        InputProps={{
          startAdornment: (
            <IconButton size="small" edge="start" disabled>
              <Search fontSize="small" />
            </IconButton>
          ),
        }}
      />
    </Box>
    <Divider />
    <Box sx={{ flex: 1, overflowY: 'auto' }}>
      {loading ? (
        <Box display="flex" justifyContent="center" p={4}>
          <CircularProgress size={28} />
        </Box>
      ) : conversations.length === 0 ? (
        <Typography variant="body2" color="text.secondary" align="center" p={4}>
          No conversations found.
        </Typography>
      ) : (
        <List disablePadding>
          {conversations.map((c) => (
            <ListItemButton
              key={c?._id}
              selected={selectedId === c?._id}
              onClick={() => onSelect?.(c?._id)}
              alignItems="flex-start"
            >
              <ListItemAvatar>
                <Badge
                  color="error"
                  badgeContent={c?.unread || 0}
                  invisible={!c?.unread}
                  overlap="circular"
                >
                  <Avatar src={c?.avatar || undefined}>{getInitials(c?.name)}</Avatar>
                </Badge>
              </ListItemAvatar>
              <ListItemText
                primary={c?.name || 'Unknown'}
                primaryTypographyProps={{
                  noWrap: true,
                  fontWeight: c?.unread ? 'bold' : 'normal',
                }}
                secondary={c?.lastMessage || c?.subject || ''}
                secondaryTypographyProps={{ noWrap: true }}
              />
            </ListItemButton>
          ))}
        </List>
      )}
    </Box>
  </>
);

export default UserList;
